module.exports = __webpack_public_path__ + "img/m2.b021a967.gif";